<style>
.custom-control-input,
.custom-control-label {
  cursor: pointer;
}

.checkbox-position-offset {
  margin-top: 35px;
  margin-left: 25px;
  margin-bottom: 10px;
}
</style>

<template>
  <div class="d-flex">
    <div
      v-for="(checkbox, index) in checkboxes"
      :key="index"
      class="custom-control custom-checkbox checkbox-position-offset"
    >
      <input
        class="custom-control-input"
        type="checkbox"
        v-model="checkbox.model"
        :name="'checkbox-' + index"
        :id="'checkbox-' + index"
      />
      <label class="custom-control-label" :for="'checkbox-' + index">{{
        checkbox.label
      }}</label>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "label", "options"],
  data() {
    return {
      checkboxes: []
    };
  },
  created() {
    this.prepareCheckboxes();
  },
  computed: {
    filter() {
      return this.checkboxes
        .filter(box => box.model)
        .map(box => box.value)
        .join(",");
    }
  },
  methods: {
    prepareCheckboxes() {
      this.checkboxes = this.options.map(option => ({
        label: option.text,
        value: option.value,
        model: false
      }));
    }
  },
  watch: {
    options() {
      this.prepareCheckboxes();
    },
    filter(value) {
      this.$emit("input", value);
    }
  }
};
</script>
:
